import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useApiClient } from "../../../api";
import { FormControl, TextField } from "@mui/material";
import { useState } from "react";
import { enqueueSnackbar } from "notistack";

function ForgotPassword({ open, handleClose }) {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const apiClient = useApiClient();

  const handleSubmit = async () => {
    try {
      const data = await apiClient.users.requestPassword({ email: email });
      if (data.success) {
        onClose();
        enqueueSnackbar("Password reset sent to your email", {
          variant: "success",
          autoHideDuration: 3000,
        });
      } else {
        setError(data.message);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const onClose = () => {
    setEmail("");
    setError("");
    handleClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Reset password</DialogTitle>
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: 2, width: "100%" }}
      >
        <DialogContentText>
          Enter your account&apos;s email address, and, if it&apos;s a match,
          we&apos;ll send you a link to reset your password.
        </DialogContentText>
        <FormControl>
          <TextField
            value={email}
            error={error}
            helperText={error}
            onChange={(e) => setEmail(e.target.value)}
            label={"Email address"}
            fullWidth
          />
        </FormControl>
      </DialogContent>
      <DialogActions sx={{ pb: 3, px: 3 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit}>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ForgotPassword.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default ForgotPassword;
